module.exports = __webpack_public_path__ + "img/icon-user-phone.b2836fa4.svg";